import { evaluate } from 'mathjs';

const TYPE_PSSESSION = 'pssession';
const TYPE_2D = '2D';
const TYPE_PLOTLY = 'plotly';
const TYPE_EXTERN_PAYLOAD = 'externpayload';

const DATA_TYPE_DATA = 'data';
const DATA_TYPE_CONC = 'concentration';
const DATA_TYPE_AOF = 'aof';
const DATA_TYPE_PICTURE = 'picture';
const DATA_TYPE_PLOTLY = 'plotly';
const DATA_TYPE_EXTERN_PAYLOAD = 'externpayload';

const iconGenericFile = 'fileIcon.png';

// Define regex patterns for file extensions
const reXLSXExt = /\.xlsx$/i;
const rePictureExt = /\.(png|jpg|jpeg|gif|bmp)$/i;

const reConcFromFile = /(\d+([.]\d+)?([e^][-]?\d+)?)[\s]?((pp[mbt])|([pnµum]?[gMm])|(ug|mg|g)(\/L|L))/;

const reMappingFromFile = RegExp('[ ]?([0-9]+)[S\\.]([0-9]+)[ -]');
const reScanFromFile = RegExp('[ ]?Scan[ ]?([0-9]+)', 'i');

const RE_TIME_HEADER_FIRST =
  /(t(ime)?[ ]?(([[(].*s[\])])|([ ]?\/[ ]?.*s)))|(^.?s$)|(^t(ime)(stamp)?$)/i;
  const RE_CURRENT_HEADER_FIRST =
  /(((^curr(ent)?)|(i))[ ]?(([[(].*A[\])])|([ ]?\/[ ]?.*A)))|(^.?A$)|(^i$)|(^curr(ent)?)/i;
const RE_VOLTAGE_HEADER_FIRST =
  /(((v)|(pot(ential)?))[ ]?((\[.*V\])|([ ]?\/[ ]?.*V)))|(^.?V$)|(^p(ot)?(ential)?($|[ ]))/i;
const RE_REVERSE_CURRENT_HEADER_FIRST =
  /rev[erse]*\s*cur/i;
const RE_STATE_HEADER_FIRST = /state/i;
const RE_SCAN_HEADER_FIRST = /^scan/i;
const RE_POTENTIAL_METROHM_HEADER_FIRST =
  /Pot(ential) applied[ ]?[([][ ]?[.]?V[ ]?[)\]]/i;
const RE_FREQUENCY_HEADER_FIRST =
  /^freq(uency)?/i;
const RE_IMPEDANCE_RE_HEADER_FIRST =
  /imp(edance)?[_-]re/i;
const RE_IMPEDANCE_IM_HEADER_FIRST =
  /imp(edance)?[_-]im/i;


class BaseParser {  
  constructor() {
    this.returnValue = this.getNewReturnValue();
  }

  getNewReturnValue() {
    return {
      success: false,
      processedData: [],
      dataType: DATA_TYPE_DATA,
      lastError: 'File not identified',
      icon:iconGenericFile,
      warnings: []
    }
  }

  async parse(parent, fileName, data, report) {
    try {
      return await this._doParse(parent, fileName, data, report);
    } catch (e) {
      this.returnValue.lastError = `Error parsing file "${fileName}": ${e}`;
      return this.returnValue;
    }
  }

  getDataFromFileName(title_curve, regexTitle = null, fileName = null) {
    const matchConc = reConcFromFile.exec(title_curve);
    const matchTitl =
        regexTitle !== null ? regexTitle.exec(title_curve) : null;
    let matchMapping = reMappingFromFile.exec(title_curve);
    const dataExtract = {
        title: title_curve,
        group: 0,
        concUnit: '',
    };
    if (matchTitl !== null) {
        dataExtract.title = matchTitl[1];
    }
    if (matchConc !== null) {
        dataExtract.group = evaluate(matchConc[1]);
        dataExtract.concUnit = matchConc[4];
    }
    // If null tries to match but with the fileName
    if (matchMapping === null && fileName !== null) {
        matchMapping = reMappingFromFile.exec(fileName);
    }
    if (matchMapping !== null) {
        dataExtract.mapping = [matchMapping[1], matchMapping[2]];
        // Check if it can extract the scan from the name.
        // Only if mapping was found, becuase it's only used here
        const matchScan = reScanFromFile.exec(title_curve);
        if (matchScan !== null) {
            dataExtract.scan = parseInt(matchScan[1]);
        }
    }
    return dataExtract;
  }

  // eslint-disable-next-line no-unused-vars
  async _doParse(parent, fileName, data, report) {
    throw new Error('_doParse must be implemented by subclass');
  }
}

async function readFileFromBlob(file, fileName){
  let result_base64 = await new Promise((resolve) => {
    const fileReader = new FileReader();
    fileReader.onload = () => resolve(fileReader.result);
    if (isPictureFile(fileName)) {
      fileReader.readAsDataURL(file);
    } else if (isXLSXFile(fileName)) {
      fileReader.readAsArrayBuffer(file);
    } else {
      fileReader.readAsText(file); //Read the files
    }
  });
  return result_base64;
}

function isPictureFile(fileName) {
  return rePictureExt.test(fileName);
}

function isXLSXFile(fileName) {
  return reXLSXExt.test(fileName);
}

export {
    TYPE_PSSESSION,
    TYPE_2D,
    TYPE_PLOTLY,
    TYPE_EXTERN_PAYLOAD,
    isPictureFile,
    isXLSXFile,
    readFileFromBlob,
    iconGenericFile,
    DATA_TYPE_DATA,
    DATA_TYPE_CONC,
    DATA_TYPE_AOF,
    DATA_TYPE_PICTURE,
    DATA_TYPE_PLOTLY,
    DATA_TYPE_EXTERN_PAYLOAD,
    BaseParser,
    RE_TIME_HEADER_FIRST,
    RE_CURRENT_HEADER_FIRST,
    RE_VOLTAGE_HEADER_FIRST,
    RE_REVERSE_CURRENT_HEADER_FIRST,
    RE_STATE_HEADER_FIRST,
    RE_SCAN_HEADER_FIRST,
    RE_POTENTIAL_METROHM_HEADER_FIRST,
    RE_FREQUENCY_HEADER_FIRST,
    RE_IMPEDANCE_RE_HEADER_FIRST,
    RE_IMPEDANCE_IM_HEADER_FIRST,
}